import moment from 'moment';

import { Box, Stack, Typography, useTheme } from '@mui/material';
import { EditHeaderProps } from 'features/Connect/features/ConnectATSIntegration/types/scorecardTypes';
import { Key } from '../../../../styles/hiringRequestStyles';

export const EditHeader: React.FC<EditHeaderProps> = ({
  created,
  templateName,
  titleText,
  reviewer,
}) => {
  const theme = useTheme();
  const formattedDate = moment(created).format('M/D/YYYY [at] h:mma');

  return (
    <Stack spacing={2} sx={{ paddingBottom: theme.spacing(2) }}>
      <Typography variant="h2">{titleText}</Typography>
      <Box>
        <Key>Reviewer</Key>
        <Typography>{reviewer}</Typography>
      </Box>
      <Box>
        <Key>Scorecard Template</Key>
        <Typography>{templateName}</Typography>
      </Box>
      <Box>
        <Typography sx={{ fontStyle: 'italic' }}>Last saved on {formattedDate}</Typography>
      </Box>
    </Stack>
  );
};
